module.exports = __webpack_public_path__ + "assets/img/andrius-terskovas.6e40bd0d.jpg";